import {useContext} from 'react';
import {WebsiteContext} from '../../index';

const DetailsAction = ({detailsPopup, onOpenModal, primary = false}) => {
    const {actionLookup = {}} = useContext(WebsiteContext);
    if (!detailsPopup?.label) return null;

    const href = detailsPopup.href;
    const validLocalHref = typeof href === 'string' && /^\/(?!\/)[a-z0-9/_-]+$/i.test(href);

    const resolvedHref = validLocalHref && (!primary || actionLookup[href] === href);

    const actionClass = primary ? 'button' : 'opacity-80 text-sm hover:opacity-100';
    return <div className={primary ? 'mt-auto pt-6' : 'mt-auto pt-4'}>
        {resolvedHref
            ? <a className={actionClass} data-details-link="" href={href}>
                {detailsPopup.label}
            </a>
            : <button
                type="button"
                className={actionClass}
                data-details-popup=""
                onClick={() => onOpenModal({label: detailsPopup.label, text: detailsPopup.text})}
            >
                {detailsPopup.label}
            </button>}
    </div>;
};

export default DetailsAction;
